import {Component, Input} from "@angular/core";
import IMeasurement from "../../interfaces/IMeasurement";
import MeasurementDataProvider from "../../services/measurementDataProvider.service";

@Component({
    selector: 'map-details-overlay',
    template: require('./mapDetailsOverlay.component.html'),
    styles: [String(require('./mapDetailsOverlay.styl'))],
})

export class MapDetailsOverlayComponent {
    @Input() public measurement : IMeasurement

    constructor(public measurementDataProvider: MeasurementDataProvider) {
    }


}



// WEBPACK FOOTER //
// ./src/app/components/mapDetailsOverlay/mapDetailsOverlay.component.ts